module.exports = __webpack_public_path__ + "img/person.98fcb7f3.svg";